import { Injectable } from "@angular/core";
import { Route, Router } from "@angular/router";
import { IBusinessFunctionFeature } from "../interfaces/ibusinessfunctionfeature";
import { IBusinessFunction } from "../interfaces/ibusinessfunction";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class RoutesService {
    currentPageTitle = new BehaviorSubject<string>('');
    /**
     * Gets a list of routes that are for navigation ordered by sort order
     * @param router
     */
    getNavigationRoutes(router: Router, businessFunction: IBusinessFunction | null): Array<Route> {
        const routes: any[] = new Array();
        const enabledFeatures: IBusinessFunctionFeature[] = businessFunction && businessFunction.features ? businessFunction.features.filter(fe => fe.enabled) : [];

        router.config.forEach((e) => {
            if (e.data) {
                if (!e.data['nav'].features) {
                    routes.push(e);
                } else {
                    // need to check the business function has the feature and if it is enabled
                    let itemFound: boolean = false;
                    e.data['nav'].features.forEach((f: number) => {
                        if (enabledFeatures.findIndex((bff: IBusinessFunctionFeature) => bff.featureId === f) > -1) {
                            itemFound = true;
                        }
                    });
                    // if the item is found, push it on to the collection
                    if (itemFound) {
                        routes.push(e);
                    }
                }
            }
        });

        // here we want to reorder the routes based on the order
        return routes.sort((a: Route, b: Route) => {
            if (a.data && b.data && parseInt(a.data['nav'].order, 10) > parseInt(b.data['nav'].order, 10)) {
                return 1;
            }
            return 0;
        });
    }

}
